import { PBRMaterial } from '@babylonjs/core/Materials/PBR/pbrMaterial'
import { DynamicTexture } from '@babylonjs/core/Materials/Textures/dynamicTexture'
import { Color3 } from '@babylonjs/core/Maths/math.color'
import { Scene } from '@babylonjs/core/scene'
import { GetUrl } from './Settings'

let engravingFont: FontFace
let engravingLogo: HTMLImageElement

export async function loadEngravingFont() {
	if (!engravingFont) {
		engravingFont = new FontFace('FuturaEngraving', `url(${GetUrl('futura-light.woff2')})`)
		document.fonts.add(engravingFont)
		await engravingFont.load()
	}
	if (!engravingLogo) {
		engravingLogo = new Image()
		engravingLogo.crossOrigin = 'Anonymous'
		engravingLogo.src = `data:image/svg+xml;utf8,<?xml version="1.0" encoding="utf-8"?>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 258.539 27.78" style="enable-background:new 0 0 258.539 27.78;" xml:space="preserve">
            <g>
                <polyline points="35.021,21.439 33.289,21.439 33.289,6.37 35.021,6.37 35.021,21.439 " />
                <polyline points="10.731,19.925 17.109,19.925 17.109,21.439 9.072,21.439 9.072,6.37 10.731,6.37 10.731,19.925  " />
                <polyline points="137.961,6.37 145.822,6.37 145.822,7.884 139.619,7.884 139.619,12.427 145.606,12.427  145.606,14.013 139.619,14.013 139.619,19.925 145.822,19.925 145.822,21.439 137.961,21.439 137.961,6.37 " />
                <polygon points="62.813,18.446 62.813,6.417 64.471,6.417 64.471,21.439 62.813,21.439 54.793,9.407 54.793,21.439  53.134,21.439 53.134,6.37 54.762,6.37 " />
                <path d="M88.896,20.669v0.002c-0.315,0.157-0.648,0.282-0.989,0.372l0,0c-1,0.263-2.031,0.396-3.064,0.396h-2.434 V6.37h2.184l0,0c0.955,0,1.908,0.084,2.848,0.252l0,0c1.098,0.197,2.12,0.691,2.953,1.434l0,0 c1.178,1.049,2.021,2.422,2.424,3.947l0,0c0.166,0.627,0.25,1.275,0.25,1.924c0,2.857-1.615,5.468-4.171,6.744 M84.066,19.925 h0.725c0.455,0,0.91-0.029,1.362-0.088l0,0c2.655-0.34,4.745-2.43,5.087-5.082l0,0c0.034-0.268,0.051-0.537,0.051-0.807 c0-1.89-0.844-3.682-2.302-4.883l0,0c-0.523-0.434-1.14-0.738-1.802-0.892l0,0c-0.855-0.199-1.732-0.301-2.609-0.301 c-0.171,0-0.342,0.006-0.512,0.012l0,0V19.925z" />
                <path d="M116.563,13.378c1.106,0.248,2.021,1.02,2.455,2.064l0,0c0.245,0.586,0.379,1.213,0.401,1.847l0,0 c0.001,0.043,0.003,0.086,0.003,0.128c0,1.65-1.074,3.109-2.65,3.6l0,0c-0.899,0.279-1.834,0.421-2.775,0.422h-3.533V6.37h2.523 h0.938l0,0c0.041-0.002,0.081-0.002,0.121-0.002c0.854,0,1.69,0.244,2.41,0.699l0,0c1.135,0.719,1.82,1.969,1.82,3.312 c0,0.527-0.105,1.049-0.312,1.535l0,0C117.689,12.558,117.192,13.077,116.563,13.378L116.563,13.378z M112.193,19.925h1.895l0,0 c0.689,0,1.371-0.137,2.01-0.398l0,0c0.959-0.396,1.586-1.331,1.586-2.369c0-1.142-0.754-2.144-1.848-2.462h0.001 c-0.597-0.173-1.212-0.261-1.832-0.261c-0.122,0-0.246,0.004-0.37,0.01h-1.442V19.925z M115.273,12.657 c0.496-0.189,0.889-0.58,1.083-1.075l0,0c0.142-0.362,0.216-0.749,0.216-1.14c0-0.281-0.039-0.562-0.115-0.836l0,0 c-0.244-0.881-0.995-1.527-1.902-1.639l0,0c-0.472-0.059-0.945-0.088-1.42-0.088c-0.098,0-0.195,0.002-0.291,0.004v0.002h-0.65 v5.117h1.285c0.632,0,1.258-0.123,1.842-0.365" />
                <path d="M166.875,6.37h0.725c0.709,0,1.413,0.125,2.078,0.369l0,0c0.764,0.28,1.404,0.818,1.814,1.517l0,0 c0.404,0.692,0.617,1.481,0.617,2.281c0,0.239-0.02,0.478-0.058,0.715l0,0c-0.233,1.451-1.22,2.668-2.578,3.197l3.618,6.988h-1.74 l-3.453-6.668l0,0c-0.27,0.023-0.537,0.035-0.807,0.035h-1.01v6.633h-1.666V6.37H166.875z M166.082,7.884v5.48h1.035l0,0 c0.021,0,0.044,0,0.066,0c0.154,0,0.307-0.006,0.461-0.018l0,0c0.68,0,1.336-0.256,1.84-0.713l0,0 c0.598-0.543,0.936-1.313,0.936-2.119c0-0.176-0.016-0.352-0.049-0.525l0,0c-0.205-1.104-1.115-1.942-2.232-2.057l0,0 c-0.309-0.033-0.618-0.049-0.928-0.049H166.082z" />
                <path d="M201.096,13.946c0.039,2.01-0.179,3.656-1.546,5.223c-1.36,1.574-3.431,2.48-5.5,2.48 c-4.18,0-7.654-3.459-7.654-7.625c0-4.275,3.475-7.755,7.752-7.755c2.602,0,4.711,1.164,6.293,3.222l-1.207,1.129 c-1.242-1.764-2.918-2.812-5.105-2.812c-3.392,0-6.074,2.87-6.074,6.235c0,1.578,0.631,3.066,1.737,4.186 c1.084,1.078,2.659,1.881,4.219,1.881c2.583,0,5.303-1.881,5.303-4.626h-4.417v-1.538H201.096z" />

            </g>
        </svg>`
		// BRILLE: <path d="M215.72,11.264c1.074-0.269,1.931-1.126,2.25-2.248c0.279-0.981-0.044-2.042-0.811-2.665 c-0.477-0.385-1.04-0.631-1.634-0.713c-0.809-0.112-1.629,0.067-2.331,0.507c-0.74,0.464-1.202,1.302-1.219,2.215 c-0.003,0.174,0.01,0.343,0.04,0.514c0.148,0.839,0.631,1.57,1.323,2.004c0.518,0.322,1.109,0.486,1.709,0.475 C215.275,11.349,215.497,11.319,215.72,11.264z M227.118,11.644c-0.579,0.291-1.146,0.42-1.783,0.409 c-0.811-0.015-1.598-0.303-2.252-0.824c-1.076-0.855-1.642-2.21-1.48-3.649c0.005-0.047-0.009-0.07-0.05-0.083 c-0.744-0.236-1.975-0.236-2.719,0c-0.042,0.013-0.056,0.036-0.05,0.083c0.162,1.439-0.404,2.794-1.48,3.649 c-0.655,0.521-1.441,0.808-2.252,0.824c-0.638,0.012-1.204-0.118-1.783-0.409c-1.169-0.587-1.946-1.904-2.041-3.292 c-0.002-0.075-0.057-0.134-0.125-0.134c-0.235,0-0.586,0-0.821,0c0-0.205,0-0.668,0-0.873c0.295,0,0.763,0,1.059,0 c0.055,0,0.107-0.044,0.124-0.102c0.242-0.651,0.678-1.25,1.237-1.609c1.097-0.705,2.412-0.891,3.639-0.515 c0.662,0.203,1.198,0.533,1.698,1.046c0.191,0.196,0.349,0.409,0.484,0.654c0.03,0.054,0.064,0.075,0.121,0.075 c0.052,0,0.105,0,0.157,0c0.015,0,0.03-0.001,0.045-0.004c0.762-0.134,1.937-0.134,2.698,0c0.015,0.003,0.03,0.004,0.045,0.004 c0.052,0,0.105,0,0.157,0c0.058,0,0.091-0.021,0.121-0.075c0.135-0.244,0.293-0.458,0.484-0.654 c0.501-0.513,1.037-0.843,1.698-1.046c1.227-0.376,2.541-0.19,3.639,0.515c0.559,0.359,0.995,0.958,1.237,1.609 c0.017,0.057,0.069,0.102,0.124,0.102c0.295,0,0.763,0,1.059,0c0,0.205,0,0.668,0,0.873c-0.235,0-0.586,0-0.821,0 c-0.069,0-0.124,0.059-0.125,0.134C229.064,9.74,228.286,11.057,227.118,11.644z M225.336,11.354 c0.6,0.011,1.191-0.153,1.709-0.475c0.693-0.434,1.175-1.164,1.323-2.004c0.03-0.17,0.043-0.34,0.04-0.514 c-0.017-0.913-0.479-1.751-1.219-2.215c-0.702-0.44-1.523-0.619-2.331-0.507c-0.594,0.082-1.157,0.328-1.634,0.713 c-0.766,0.623-1.089,1.684-0.811,2.665c0.319,1.122,1.176,1.978,2.25,2.248C224.885,11.321,225.107,11.35,225.336,11.354z" />
		await engravingLogo.decode()
	}
}

export class EngravingMaterial extends PBRMaterial {
	texture: DynamicTexture

	text: string
	mirror: Boolean
	ratio: number

	constructor(name: string, scene: Scene) {
		super(name, scene)
		this.zOffset = -5
		// this.metallic = 0
		this.backFaceCulling = false
		this.albedoColor = Color3.Black()
		this.emissiveColor = new Color3(.1, .1, .1)
		this.metallic = 0
		this.roughness = 1
	}

	drawLogo(mirror: Boolean, ratio = 10 / 1) {
		if (mirror == this.mirror && ratio == this.ratio) return
		if (!engravingLogo) console.warn('ENGRAVING LOGO NOT LOADED')

		this.mirror = mirror
		this.ratio = ratio
		this.texture?.dispose()

		const height = 128
		const width = Math.round(height * ratio)

		this.texture = new DynamicTexture('ENGRAVING-LOGO', { width: width, height: height }, this.getScene(), null, null, null, false)
		const context = this.texture.getContext()

		context.setTransform(-1, 0, 0, 1, width, 0)

		const imageHeight = height
		const imageWidth = engravingLogo.width / engravingLogo.height * 128

		let paddingTop = (height - imageHeight) / 2
		let paddingLeft = (width - imageWidth) / 2

		context.drawImage(engravingLogo, paddingLeft, paddingTop, imageWidth, imageHeight)

		this.texture.update()
		this.texture.hasAlpha = true

		this.albedoTexture = this.texture
	}

	drawText(text: string, mirror: Boolean, ratio: number = 10 / 1) {
		if (text == this.text && mirror == this.mirror && ratio == this.ratio) return
		this.text = text
		this.mirror = mirror
		this.ratio = ratio
		this.texture?.dispose()

		const height = 128
		const width = Math.round(height * ratio)

		this.texture = new DynamicTexture('ENGRAVING-NAME', { width: width, height: height }, this.getScene())
		const context = this.texture.getContext()

		context.setTransform(-1, 0, 0, 1, width, 0)

		// context.beginPath()
		// context.rect(1, 1, width - 2, height - 2)
		// context.stroke()

		const lines = text.split('\n')
		const lineHeight = height / lines.length

		let fontSize = lineHeight
		context.font = `${fontSize}px "FuturaEngraving"`
		while (context.measureText(text).width > width) {
			fontSize -= 1
			context.font = `${fontSize}px "FuturaEngraving"`
			// console.log(context.font)
		}
		for (let i = 0; i < lines.length; i++) {
			const metric = context.measureText(lines[i]) as TextMetrics
			// console.log(metric)
			const fontHeight = metric.fontBoundingBoxAscent + metric.fontBoundingBoxDescent
			const actualHeight = metric.actualBoundingBoxAscent + metric.actualBoundingBoxDescent

			context.fillStyle = 'black'
			let paddingTop = (lineHeight - actualHeight) / 2
			let paddingLeft = (width - metric.width) / 2
			context.fillText(lines[i], paddingLeft, (actualHeight - metric.actualBoundingBoxDescent + paddingTop) + i * lineHeight)

			// context.drawImage(image, 0, 0)
		}
		this.texture.update()
		this.texture.hasAlpha = true

		this.albedoTexture = this.texture
	}
}
